module.exports = __webpack_public_path__ + "static/media/fava-beans.ed9cc66d.png";